
































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
//import echarts from "echarts";
import XLSX from "@/lib/Common/excel";
import SearchTree from "@/lib/Common/searchtree";

class PageUserRequest extends PageRequest {
  keyword: string;
  areaId: number;
  startTime: string;
  endTime: string;
  totaltype: number;
  operaType: number;
  customerId: string;
}

@Component({
  components: {},
})
export default class CustomerUseTotalCount extends AbpBase {
  pagerequest: PageUserRequest = new PageUserRequest();
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  itemId: string = "0";
  height: number = 300;
  usebar: any; //图表
  useCount: number = 0;
  loadsear: boolean = false;
  splitnum: number = 0.15;
  get list() {
    return this.$store.state.readrecord.list;
  }
  get loading() {
    return this.$store.state.readrecord.loading;
  }
  pageChange(page: number) {
    this.$store.commit("readrecord/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("readrecord/setPageSize", pagesize);
    this.getpage();
  }
  changeSort(key) {
    this.pagerequest.sorting = key.key + " " + key.order;
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    //console.log(item)
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("readrecord/setCurrentPage", 1);
    this.getpage();
  }
  getSearch() {
    this.$store.commit("readrecord/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.loadsear = true;
    //this.usebar.resize();
    await this.$store
      .dispatch({
        type: "readrecord/getCustomerUseTotal",
        data: this.pagerequest,
      })
      .then((val) => {
        console.log(val)
        this.loadsear = false;
        this.$store.state.readrecord.totalCount = val.rowCount;
        this.$store.state.readrecord.list = val.tableData;
        this.useCount = val.useTotalCount;
      })
      .catch((err) => {
        this.loadsear = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
  }
  get pageSize() {
    return this.$store.state.readrecord.pageSize;
  }
  get totalCount() {
    return this.$store.state.readrecord.totalCount;
  }
  get currentPage() {
    return this.$store.state.readrecord.currentPage;
  }
  //时间改变
  changdate(val) {
    if (val.length > 1) {
      this.pagerequest.startTime = Moment(val[0], "YYYY-MM-DD HH:mm:ss")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.pagerequest.endTime = Moment(val[1], "YYYY-MM-DD HH:mm:ss")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    //this.treedata = [];
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //区域树形
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("CurrentTenant"),
      key: "customerName",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title:
                params.row.customerName == null
                  ? this.L("Unknown")
                  : params.row.customerName,
            },
          },
          params.row.customerName == null
            ? this.L("Unknown")
            : params.row.customerName
        );
      },
    },
    {
      title: this.L("Mobile"),
      key: "mobile",
      width: 130,
    },
    {
      title: this.L("CustomerType"),
      key: "customerType",
      width: 130,
      sortable: true,
    },
    {
      title: "表计类型",
      key: "meterTypeName",
      width: 130,
      sortable: true,

    },
    {
      title: this.L("LastRead"),
      key: "lastRead",
      sortable: true,
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.lastRead == null
            ? 0
            : parseFloat(params.row.lastRead).toFixed(4)
        );
      },
    },
    {
      title: this.L("ThisRead"),
      key: "thisRead",
      sortable: true,
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.thisRead == null
            ? 0
            : parseFloat(params.row.thisRead).toFixed(4)
        );
      },
    },
    {
      title: this.L("ThisUse"),
      key: "thisUse",
      sortable: true,
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.thisUse == null
            ? 0
            : parseFloat(params.row.thisUse).toFixed(4)
        );
      },
    },
    {
      title: this.L("Time"),
      key: "readTimeStr",
      sortable: true,
      width: 150,
    },
  ];
  async created() {
    this.pagerequest.totaltype = 2;
    this.pagerequest.startTime = Moment()
      .add(-6, "days")
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getAreaTree();
    this.getcustomerlist();
    //this.getpage();
  }
  mounted() {
    this.pagerequest.totaltype = 1;
    // if (window.innerHeight > 800) {
    //   (document.getElementById("echarts") as HTMLDivElement).style.height =
    //     "300px";
    //   this.height = window.innerHeight - 610;
    // } else {
    //   (document.getElementById("echarts") as HTMLDivElement).style.height =
    //     "150px";
    //   this.height = window.innerHeight - 460;
    // }
    // this.usebar = echarts.init(
    //   document.getElementById("echarts") as HTMLDivElement
    // );
    // //自动缩放
    // window.addEventListener("resize", () => {
    //   this.usebar.resize();
    // });
  }
  //汇总当前页数据
  handleSummary({ columns, data }) {
    const sums = {};
    columns.forEach((column, index) => {
      const key = column.key;
      if (index == 1) {
        sums[key] = {
          key,
          value: "合计",
        };
        return;
      }
      if (index == 1 || index == 2 || index == 3 || index == 4 || index == 8) {
        sums[key] = {
          key,
          value: "",
        };
        return;
      }
      const values = data.map((item) => Number(item[key]));
      if (!values.every((value) => isNaN(value))) {
        const v = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
        sums[key] = {
          key,
          value: v.toFixed(2),
        };
      } else {
        sums[key] = {
          key,
          value: "",
        };
      }
    });
    return sums;
  }
  //导出数据
  async exportdata(type: any) {
    this.loadsear = true;
    /**导出当前页 */
    if (type === 'exportCurrentPage') {
      let datalist = this.list;
      if (datalist.length === 0) {
        this.$Message.warning({
          content: "无数据",
        })
      } else {
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        datalist.forEach((ele) => {
          let info = ite.filter((p) => {
            return p.id == ele.meterType;
          });
          if (info.length > 0) {
            ele.meterType = info[0].name;
          }
          ele.readTime = Moment(ele.readTime).format("YYYY-MM-DD HH:mm:ss")
        });
        this.exportList(datalist);
      }
      this.loadsear = false;
    } else {
      /**导出所有数据 */
      this.pagerequest.maxResultCount = 1000;
      this.$store
        .dispatch({
          type: "readrecord/ExportCustomerUseTotal",
          data: this.pagerequest,
        })
      this.$Message.success({
        content: "导出需求已提交，请在下载中心下载导出文件，由于导出数据量不同，等待时间不同",
      })
      this.loadsear = false;
    }
    this.loadsear = false;

  }
  //XLXS导出数据
  exportList(list) {
    let title = [
      "客户名称",
      "手机",
      "客户类型",
      "表计类型",
      "期初数",
      "期末数",
      "总用量",
      "时间",
    ];
    let keylist = [
      "customerName",
      "mobile",
      "customerType",
      "meterTypeName",
      "lastRead",
      "thisRead",
      "thisUse",
      "readTimeStr",
    ];
    let filename = Moment().format("YYYYMMDDHHmmss");
    const param = {
      title: title,
      key: keylist,
      data: list,
      autoWidth: true,
      filename: filename,
    };
    XLSX.export_array_to_excel(param);
  }
  /**
   * 客户
   */
  async getcustomerlist() {
    await this.$store
      .dispatch({ type: "customer/getallcustomer" })
      .then((val) => {
        if (val.length > 0) {
          this.$data.customerlist = [];
          val.forEach((ele) => {
            this.$data.customerlist.push({
              label: ele.name.trim(),
              value: ele.id,
            });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  data() {
    return {
      customerlist: [],
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              return [start, end];
            },
          },
        ],
      },
      //柱形图参数
      baroption(bardto) {
        return {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "line", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          legend: {
            data: bardto.legend,
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              data: bardto.xAxis,
            },
          ],
          yAxis: [
            {
              type: "value",
            },
          ],
          series: bardto.series,
        };
      },
    };
  }
}
